import "./src/styles/index.scss";
import 'jquery/dist/jquery.min.js';
import 'popper.js/dist/popper.min';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import 'crypto-js/md5';
import './src/configs';

import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider